import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSiteStore } from '../../utils/store/useSiteStore';
import useIsMobile from '../../utils/hooks/useIsMobile';
import MobileNav from './MobileNav';
import s from '../../styles/components/general/Header.module.css';
import site from '../../data/master.json';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { cta } = site.header;
  const { sections, navLinks } = useSiteStore();
  const isMobile = useIsMobile();
  const activeLinks = navLinks.filter(link => link.section === null || sections[link.section]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`${s.container} ${scrolled ? s.scrolled : ''}`}>
      {isMobile ? (
        <>
          <MobileNav links={activeLinks} />
          <a href={cta.url} className={s.orderBtn}>{cta.label}</a>
        </>
      ) : (
        <>
          <nav className={s.navLinks}>
            {activeLinks.map((link) => (
              <Link key={link.label} to={link.path} className={s.link}>
                {link.label}
              </Link>
            ))}
          </nav>
          <a href={cta.url} className={s.orderBtn}>{cta.label}</a>
        </>
      )}
    </header>
  );
}